module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form"
  }, [_c('el-form', {
    staticStyle: {
      "margin": "20px",
      "width": "90%",
      "min-width": "600px"
    },
    attrs: {
      "label-width": "180px"
    }
  }, [_c('el-form-item', {
    staticClass: "edit-form",
    attrs: {
      "label": "销售下单号"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.Form.OrderCode))])]), _vm._v(" "), _c('el-form-item', {
    staticClass: "edit-form",
    attrs: {
      "label": "发货通知单号"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.Form.SendCode))])]), _vm._v(" "), _c('el-form-item', {
    staticClass: "edit-form",
    attrs: {
      "label": "出库单号"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.Form.StockOutCode))])]), _vm._v(" "), _c('el-form-item', {
    staticClass: "edit-form w100",
    attrs: {
      "label": "代理商"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.Form.AgentCode) + " " + _vm._s(_vm.Form.AgentName) + " " + _vm._s(_vm.Form.AgentAddress) + " " + _vm._s(_vm.Form.AgentTel))])]), _vm._v(" "), _c('el-form-item', {
    staticClass: "edit-form",
    attrs: {
      "label": "业务员"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.Form.SaleEmployeeName))])]), _vm._v(" "), _c('el-form-item', {
    staticClass: "edit-form",
    attrs: {
      "label": "实际发货时间"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.Form.StockOutTime))])]), _vm._v(" "), _c('el-form-item', {
    staticClass: "edit-form",
    attrs: {
      "label": "实际签收时间"
    }
  }, [(_vm.Form.SignTime != '' && _vm.Form.SignTime != undefined) ? _c('span', [_vm._v(_vm._s(_vm.Form.SignTime))]) : _c('span', [_vm._v("--")])]), _vm._v(" "), _c('el-form-item', {
    staticClass: "edit-form",
    attrs: {
      "label": "发货通知单发货情况"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.Form.DeliveryStatusName))])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.Form.ProjectType == 2),
      expression: "Form.ProjectType==2"
    }]
  }, [_c('el-form-item', {
    staticClass: "edit-form w100",
    attrs: {
      "label": "Hi幼教样机数量"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.Form.ProtoTypeNum))])]), _vm._v(" "), _c('el-form-item', {
    staticClass: "edit-form w100",
    attrs: {
      "label": "样机已抵扣数"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.Form.ProtoTypeDeductibleNum))])]), _vm._v(" "), _c('el-form-item', {
    staticClass: "edit-form w100",
    attrs: {
      "label": "此单需抵扣数"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.Form.OrderProtoTypeDeductibleNum))])])], 1), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.Form.PackageName != ''),
      expression: "Form.PackageName!=''"
    }],
    staticClass: "edit-form",
    attrs: {
      "label": "套餐名称"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.Form.PackageName))])]), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.Form.ListGoods != ''),
      expression: "Form.ListGoods!=''"
    }],
    staticClass: "edit-form",
    staticStyle: {
      "width": "900px"
    },
    attrs: {
      "label": "商品"
    }
  }, [_c('el-table', {
    staticStyle: {
      "width": "80%",
      "margin-left": "25px"
    },
    attrs: {
      "data": _vm.Form.ListGoods,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "ProName",
      "label": "名称"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "包含单品",
      "width": "240"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.PackDetail.length == 0) ? _c('div', [_vm._v("--")]) : _c('div', {
          staticClass: "dpDvCtnCss"
        }, _vm._l((scope.row.PackDetail), function(PackDetail) {
          return _c('div', {
            staticClass: "dpDvCss"
          }, [_vm._v(_vm._s(PackDetail.ProName))])
        }))]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "ProNum",
      "label": "实发"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "ReceiveNum",
      "label": "实收"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.Form.GiftGoods != ''),
      expression: "Form.GiftGoods!=''"
    }],
    staticClass: "edit-form",
    staticStyle: {
      "width": "900px"
    },
    attrs: {
      "label": "赠品"
    }
  }, [_c('el-table', {
    staticStyle: {
      "width": "80%",
      "margin-left": "25px"
    },
    attrs: {
      "data": _vm.Form.GiftGoods,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "ProName",
      "label": "名称"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "包含单品",
      "width": "240"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.PackDetail.length == 0) ? _c('div', [_vm._v("--")]) : _c('div', {
          staticClass: "dpDvCtnCss"
        }, _vm._l((scope.row.PackDetail), function(PackDetail) {
          return _c('div', {
            staticClass: "dpDvCss"
          }, [_vm._v(_vm._s(PackDetail.ProName))])
        }))]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "NeedSendNum",
      "label": "应发数"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "ProNum",
      "label": "实发"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "ReceiveNum",
      "label": "实收"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "edit-form w100",
    attrs: {
      "label": "签收凭证"
    }
  }, [_c('div', {
    staticClass: "show-img-ctn uclear"
  }, [_vm._l((_vm.Form.ReceiptPic), function(item, index) {
    return [_c('div', {
      staticClass: "show-img-cell",
      on: {
        "click": function($event) {
          _vm.LookPicture(item.Url)
        }
      }
    }, [_c('img', {
      attrs: {
        "alt": item.Name,
        "src": item.Url
      }
    })])]
  })], 2)]), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.Form.ApplyPic.length > 0),
      expression: "Form.ApplyPic.length>0"
    }],
    attrs: {
      "label": "租用申请表"
    }
  }, [_c('div', {
    staticClass: "show-img-ctn uclear"
  }, [_vm._l((_vm.Form.ApplyPic), function(item, index) {
    return [_c('div', {
      staticClass: "show-img-cell",
      on: {
        "click": function($event) {
          _vm.LookPicture(item.Url)
        }
      }
    }, [_c('img', {
      attrs: {
        "alt": item.Name,
        "src": item.Url
      }
    })])]
  })], 2)]), _vm._v(" "), _c('el-form-item', {
    staticClass: "edit-form w100",
    attrs: {
      "label": "收货地址"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.Form.AgentConsignee))])]), _vm._v(" "), _c('el-form-item', {
    staticClass: "edit-form",
    attrs: {
      "label": "收货人及联系方式"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.Form.Consignee) + "--" + _vm._s(_vm.Form.ConsigneeTel))])]), _vm._v(" "), _c('el-form-item', {
    staticClass: "edit-form w100",
    attrs: {
      "label": "下单备注"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.Form.OrderRemark))])]), _vm._v(" "), _c('el-form-item', {
    staticClass: "edit-form",
    attrs: {
      "label": "寄送方式"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.Form.SendModeName))])]), _vm._v(" "), _c('el-form-item', {
    staticClass: "edit-form",
    attrs: {
      "label": "支付方式"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.Form.PayModeName))])]), _vm._v(" "), _c('el-form-item', {
    staticClass: "edit-form",
    attrs: {
      "label": "快递或物流名称"
    }
  }, [(_vm.Form.LogisticsName != '' && _vm.Form.LogisticsName != undefined) ? _c('span', [_vm._v(_vm._s(_vm.Form.LogisticsName))]) : _c('span', [_vm._v("--")])]), _vm._v(" "), _c('el-form-item', {
    staticClass: "edit-form",
    attrs: {
      "label": "快递或物流单号"
    }
  }, [(_vm.Form.LogisticsCode != '' && _vm.Form.LogisticsCode != undefined) ? _c('span', [_vm._v(_vm._s(_vm.Form.LogisticsCode))]) : _c('span', [_vm._v("--")])]), _vm._v(" "), _c('el-form-item', {
    staticClass: "edit-form",
    attrs: {
      "label": "包裹件数"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.Form.PackageNum))])]), _vm._v(" "), _c('el-form-item', {
    staticClass: "edit-form",
    attrs: {
      "label": "出库单备注"
    }
  }, [(_vm.Form.Remark != '' && _vm.Form.Remark != undefined) ? _c('span', [_vm._v(_vm._s(_vm.Form.Remark))]) : _c('span', [_vm._v("--")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.Form.ReceiveTypeName != '未反馈'),
      expression: "Form.ReceiveTypeName!='未反馈'"
    }]
  }, [_c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    staticClass: "edit-form",
    staticStyle: {
      "font-weight": "bold",
      "margin": "0px 0"
    },
    attrs: {
      "label": "客户反馈"
    }
  }), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "类型"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.Form.ReceiveTypeName))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "签收单"
    }
  }, [_vm._l((_vm.SignImg), function(item) {
    return _c('div', {
      staticClass: "ImgPrev"
    }, [_c('div', {
      staticClass: "post-format-content"
    }, [_c('div', {
      staticClass: "post-thumbnail"
    }, [_c('img', {
      staticClass: "attachment-thumbnail wp-post-image myProPic",
      attrs: {
        "src": item.Url
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "content-wrap"
    }, [_c('span', {
      staticClass: "entry-title"
    }, [_c('span', {
      staticClass: "featured-image"
    }, [_c('i', {
      staticClass: "el-icon-view",
      on: {
        "click": function($event) {
          _vm.LookPicture(item.Url)
        }
      }
    })])])])])])
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.SignImg.length == 0),
      expression: "SignImg.length==0"
    }]
  }, [_vm._v("--")])], 2), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "其他图片"
    }
  }, [_vm._l((_vm.OtherImg), function(item) {
    return _c('div', {
      staticClass: "ImgPrev"
    }, [_c('div', {
      staticClass: "post-format-content"
    }, [_c('div', {
      staticClass: "post-thumbnail"
    }, [_c('img', {
      staticClass: "attachment-thumbnail wp-post-image myProPic",
      attrs: {
        "src": item.Url
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "content-wrap"
    }, [_c('span', {
      staticClass: "entry-title"
    }, [_c('span', {
      staticClass: "featured-image"
    }, [_c('i', {
      staticClass: "el-icon-view",
      on: {
        "click": function($event) {
          _vm.LookPicture(item.Url)
        }
      }
    })])])])])])
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.OtherImg.length == 0),
      expression: "OtherImg.length==0"
    }]
  }, [_vm._v("--")])], 2), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "备注"
    }
  }, [(_vm.Form.CustomerRemark != '' && _vm.Form.CustomerRemark != undefined) ? _c('span', [_vm._v(_vm._s(_vm.Form.CustomerRemark))]) : _vm._e()])], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "edit-form",
    attrs: {
      "label": ""
    }
  }, [_c('el-button', {
    attrs: {
      "plain": true,
      "type": "info"
    },
    on: {
      "click": function($event) {
        _vm.goBack()
      }
    }
  }, [_vm._v("我知道了")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "size": "small"
    },
    model: {
      value: (_vm.PictureVisible),
      callback: function($$v) {
        _vm.PictureVisible = $$v
      },
      expression: "PictureVisible"
    }
  }, [_c('img', {
    attrs: {
      "width": "100%",
      "src": _vm.dialogImageUrl,
      "alt": ""
    }
  })])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-52b9d124!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/StockOut/StockOutHXView.vue
// module id = 1481
// module chunks = 1